function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Paginator } from '@domain-group/fe-blueprint-ui/pagination';
import { LocalityState, LocalityType } from '@domain-group/fe-allhomes-library';
import { SearchQuery } from '@domain-group/fe-allhomes-search-api';
import AllhomesBreadcrumbs from '@domain-group/fe-co-allhomes-breadcrumbs';
import { AllhomesSearchListingCard } from '@domain-group/fe-co-allhomes-listing-card';
import MobileDialog from '@domain-group/fe-co-allhomes-mobile-dialog';
import { AllhomesSearchSorting, AllhomesSearchSortingMobile, AllhomesSearchSortingTablet } from '../components/sorting';
import Spinner from '../components/spinner';
import NewSearchPageNoResults from '../components/new-search-page-no-results';
import { RegionSelector } from '../components/region-selector';
import localityPropType, { regionGroupPropTypes } from '../proptypes/locality';
import pageWrapper from '../wrappers';
import * as styles from './allhomes-new-search-results.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var baseClass = 'allhomes-new-listings';
class AllhomesNewSearchResults extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "filters", () => this.props.searchQuery.filters);
    _defineProperty(this, "sortOrder", () => this.props.searchQuery.getSortUrl());
    _defineProperty(this, "currentPage", () => this.props.searchQuery.page.value);
    this.state = {
      backToSearchUrl: null
    };
    props.getPageRefCallback(this);
  }
  render() {
    var _this$props$media = this.props.media,
      desktop = _this$props$media.desktop,
      tablet = _this$props$media.tablet,
      mobile = _this$props$media.mobile;
    var listingList = this.props.searchResults.map(result => ___EmotionJSX("div", {
      css: styles.row,
      key: result.listing.id
    }, ___EmotionJSX(AllhomesSearchListingCard, _extends({
      css: styles.item,
      appearance: mobile ? 'vertical' : 'horizontal',
      listingType: this.props.listingType,
      onAddToWatchlist: this.props.onAddToWatchlistForListView
    }, result))));
    var locationType = "".concat(this.props.localityLength, " locations");
    if (this.props.singleLocality) {
      var state = (get(this.props.singleLocality, 'metaData.state') || '').toUpperCase();
      if (state === LocalityState.ACT.abbreviation && this.props.singleLocality.type === LocalityType.REGION.type) {
        locationType = 'All Canberra, ACT';
      } else {
        locationType = "".concat(this.props.singleLocality.name, ", ").concat(state).trim();
      }
    }
    var regionSelector = ___EmotionJSX(RegionSelector, {
      listingType: this.props.listingType,
      filters: this.filters(),
      onSubmitFilter: this.props.onSubmitFilter,
      regionGroup: this.props.regionGroup,
      singleLocality: this.props.singleLocality
    });
    var heading = ___EmotionJSX("h1", {
      css: styles.summary
    }, ___EmotionJSX("span", {
      css: styles.summaryStat
    }, this.props.totalHits, " new price", ' ', this.props.totalHits === 1 ? 'property' : 'properties', " in \xA0"), mobile && locationType, (tablet || desktop) && regionSelector);
    return ___EmotionJSX("section", null, ___EmotionJSX("div", {
      css: styles.topContent
    }, ___EmotionJSX(AllhomesBreadcrumbs, {
      css: styles.breadcrumbs,
      items: this.props.breadcrumbs,
      goBackText: this.state.backToSearchUrl ? 'Back to Browse' : null,
      goBackUrl: this.state.backToSearchUrl
    }), ___EmotionJSX("div", {
      css: styles.items
    }, desktop || tablet ? ___EmotionJSX(Fragment, null, heading, ___EmotionJSX("div", {
      css: styles.controls
    }, desktop ? ___EmotionJSX(AllhomesSearchSorting, {
      listingType: this.props.listingType,
      value: this.sortOrder(),
      onSelect: this.props.onSortChange
    }) : ___EmotionJSX(AllhomesSearchSortingTablet, {
      align: "right",
      listingType: this.props.listingType,
      value: this.sortOrder(),
      onSelect: this.props.onSortChange
    }))) : ___EmotionJSX(Fragment, null, regionSelector, ___EmotionJSX("div", {
      css: styles.mobileHeader
    }, heading, ___EmotionJSX("div", {
      css: styles.sortControls
    }, ___EmotionJSX("button", {
      type: "button",
      css: styles.sortButton,
      onClick: () => {
        this.props.onShowSortDialogue(true);
      }
    }, "Sort")))))), ___EmotionJSX("div", {
      css: styles.itemsContainer
    }, this.props.searchPending && ___EmotionJSX(Spinner.Overlay, null), ___EmotionJSX("div", {
      css: styles.searchContent({
        hasNoResult: isEmpty(this.props.searchResults)
      })
    }, !isEmpty(this.props.searchResults) && ___EmotionJSX("div", {
      css: styles.items
    }, listingList), isEmpty(this.props.searchResults) && ___EmotionJSX(NewSearchPageNoResults, null), this.props.totalPages > 1 && ___EmotionJSX(Paginator, {
      currentPage: this.currentPage(),
      totalPages: this.props.totalPages,
      urlTemplate: this.props.paginatorUrlTemplate,
      onPageChange: this.props.onPageChange
    }))), this.props.showSortDialogue && ___EmotionJSX(MobileDialog, {
      title: "Sort by",
      closeButton: true,
      onClose: () => this.props.onShowSortDialogue(false),
      className: "".concat(baseClass, "__sort-dialogue")
    }, ___EmotionJSX(AllhomesSearchSortingMobile, {
      listingType: this.props.listingType,
      value: this.sortOrder(),
      onSelect: selection => {
        this.props.onSortChange(selection);
      }
    })));
  }
}
AllhomesNewSearchResults.propTypes = {
  searchQuery: PropTypes.instanceOf(SearchQuery).isRequired,
  media: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({})),
  listingType: PropTypes.string.isRequired,
  searchResults: PropTypes.array,
  // eslint-disable-line react/forbid-prop-types
  localityLength: PropTypes.number.isRequired,
  singleLocality: localityPropType,
  isDefaultSearch: PropTypes.bool,
  featuredProperties: PropTypes.array,
  // eslint-disable-line react/forbid-prop-types
  propertiesOfTheWeek: PropTypes.arrayOf(PropTypes.shape({})),
  searchPending: PropTypes.bool,
  totalPages: PropTypes.number,
  totalHits: PropTypes.number,
  paginatorUrlTemplate: PropTypes.string.isRequired,
  showSortDialogue: PropTypes.bool,
  onPageChange: PropTypes.func,
  onSortChange: PropTypes.func,
  onAddToWatchlistForListView: PropTypes.func,
  onClearFilter: PropTypes.func,
  onShowSortDialogue: PropTypes.func,
  getPageRefCallback: PropTypes.func,
  onFeaturePropertyClick: PropTypes.func,
  onSubmitFilter: PropTypes.func,
  regionGroup: regionGroupPropTypes,
  sendEvent: PropTypes.func
};
AllhomesNewSearchResults.defaultProps = {
  searchPending: false,
  breadcrumbs: [],
  searchResults: [],
  singleLocality: null,
  isDefaultSearch: false,
  featuredProperties: [],
  propertiesOfTheWeek: [],
  totalPages: 1,
  totalHits: 0,
  showSortDialogue: false,
  onPageChange: () => {},
  onSortChange: () => {},
  onAddToWatchlistForListView: () => {},
  onClearFilter: () => {},
  onShowSortDialogue: () => {},
  getPageRefCallback: () => {},
  onFeaturePropertyClick: () => {},
  onSubmitFilter: () => {},
  regionGroup: {},
  sendEvent: () => {}
};
export default pageWrapper()(AllhomesNewSearchResults);
export { AllhomesNewSearchResults as BaseAllhomesNewSearchResults };